/**
 * 开票入口按钮
 */
import React, { useRef, useState } from 'react';
import { Button } from 'antd';
import { ButtonType } from 'antd/lib/button';

import useInvoicePortal from '@/pages/bill/invoice/index';
import InvoicedHistoryModal, {
  InvoicedHistoryModalRef,
} from '@/pages/bill/invoice/components/InvoicedHistoryModal';
import { OrderTypeEnum } from './constant';
import { getOrderInvoices } from './helper';

interface IProps {
  authkey: string;
  text: string; // 按钮文案
  type: ButtonType; // 按钮类型
  icon?: any; // 按钮icon
  disabled?: boolean; // 按钮禁用
  isView?: boolean; // 预览 不能进行开票操作
  logId?: any; // 预览时 必需
  orderInfo?: { orderNo: string; orderType: OrderTypeEnum }; // 从某个订单进行开票 时必须
  callback?: () => void; // 回调函数
}

const Index: React.FC<IProps> = ($$) => {
  // 开票抽屉
  const invoicePortal = useInvoicePortal();
  // 开票历史弹框
  const invoicedHistoryRef = useRef<InvoicedHistoryModalRef>(null);
  const [btnLoading, setBtnLoading] = useState<boolean>(false);

  // 开票按钮点击
  const invoiceBtnHandle = async () => {
    setBtnLoading(true);
    try {
      // 不是从某个订单进入直接打开开票抽屉
      if (!$$.orderInfo) {
        // 打开开票抽屉
        invoicePortal.showDrawer({
          isView: $$.isView,
          orders: $$.orderInfo ? [{ ...$$.orderInfo }] : null,
          logId: $$.logId,
          callback: $$.callback,
        });
        setBtnLoading(false);
        return;
      }

      const { invoices, moreInvoiceFlag } = await getOrderInvoices(
        $$.orderInfo.orderNo,
        $$.orderInfo.orderType,
      );
      // 没有开过票
      if (!invoices || invoices.length === 0) {
        // 打开开票抽屉
        invoicePortal.showDrawer({
          isView: $$.isView,
          orders: $$.orderInfo ? [{ ...$$.orderInfo }] : null,
          callback: $$.callback,
        });
        setBtnLoading(false);
        return;
      }
      // 开过票 打开开票历史弹框;
      invoicedHistoryRef.current.openModal({
        invoices,
        moreInvoiceFlag,
        orders: $$.orderInfo ? [{ ...$$.orderInfo }] : null,
      });

      setBtnLoading(false);
    } catch (error) {
      setBtnLoading(false);
    }
  };

  return (
    <>
      <Button
        type={$$.type}
        onClick={invoiceBtnHandle}
        loading={btnLoading}
        icon={$$.icon}
        disabled={$$.disabled}
        data-authkey={$$.authkey}
      >
        {$$.text}
      </Button>
      <InvoicedHistoryModal innerRef={invoicedHistoryRef} callback={$$.callback} />
    </>
  );
};

export default Index;
